import { TypeScriptIcon } from "components/icons/typescript";
import React from "react";

export const S10 = () => <TypeScriptIcon color="#FFFFFF" height="60vh" width="60vh" />;
